// import {
//   DecryptCommand,
//   DecryptCommandInput,
//   EncryptionAlgorithmSpec,
// } from "@aws-sdk/client-kms";
// import { Buffer } from "buffer";
// import { decryptionClient } from "config/kms";
import forge from "node-forge";
import { getPublicEncryptionKey } from "./utils";

// const { decryptionARNKey } = getKMSKeys();

export async function encryptText(text: string) {
  try {
    const publicKeyPem = getPublicEncryptionKey();

    if (!publicKeyPem) {
      throw new Error("Public key is not set");
    }

    const formattedPem = publicKeyPem.replace(/\\n/g, "\n").trim();

    const publicKey = forge.pki.publicKeyFromPem(formattedPem);

    const encryptedBytes = publicKey.encrypt(text, "RSA-OAEP", {
      md: forge.md.sha1.create(),
      mgf1: forge.mgf.mgf1.create(forge.md.sha1.create()),
    });

    return forge.util.encode64(encryptedBytes);
  } catch (error) {
    console.error("Error encrypting password:", error);
    throw error;
  }
}

// export async function decryptText(encryptedText: string) {
//   const params: DecryptCommandInput = {
//     KeyId: decryptionARNKey,
//     CiphertextBlob: Buffer.from(encryptedText, "base64"),
//     EncryptionAlgorithm: process.env
//       .REACT_APP_KMS_ENCRYPTION_ALGORITHM as EncryptionAlgorithmSpec,
//   };

//   try {
//     const command = new DecryptCommand(params);
//     const response = await decryptionClient.send(command);

//     if (!response.Plaintext) {
//       throw new Error("Decryption failed: Plaintext is undefined");
//     }

//     return Buffer.from(response.Plaintext).toString("utf-8");
//   } catch (error) {
//     console.error("Error decrypting text:", error);
//     throw error;
//   }
// }
